<template lang="pug">
  v-container.align-self-start(no-gutters)
    v-snackbar( v-model="snackBar" :color="snackBarColor" ) {{ snackBarMessage }}
      template( v-slot:action="{attrs}")
        v-btn(text v-bind="attrs"
          @click="snackBar = false") {{ $t('buttons.closeButtonLabel') }}
    v-card(flat)
      v-card-title {{ $t('navigationItem.creditPageLabel') }}
      v-card-text
        v-tabs
          v-tab {{ $t('creditPage.creditBalanceTabTitle') }}
          v-tab {{ $t('creditPage.creditMovementsTabTitle') }}

          v-tab-item
            v-row.mt-10.ml-1(v-if="!fetchInProgress")
              span.font-weight-bold.text-h3(:class="getColor(currentUser.currentCreditBalance)") {{ currentUser.formattedCurrentCreditBalance }}
              v-icon.font-weight-bold.ml-2(x-large :class="getColor(currentUser.currentCreditBalance)") fal fa-euro-sign

            v-skeleton-loader(v-else type="paragraph@1 " width="100%").mt-10

          v-tab-item
            v-card.fill-height(flat v-if="!fetchInProgress")
              v-row.ma-0
                v-col( cols="12" sm="12" md="8" lg="8")
                  v-list
                    v-list-item(v-for="(item, idx) in creditDetails" :key="idx")
                      v-list-item-content
                        v-row.ma-0(no-gutters)
                          v-col(cols="6" )
                            v-list-item-title
                              div.font-weight-bold.title {{formatDate(item.createdAt)}}
                          v-col(cols="6")
                            v-row.ma-0
                              v-spacer
                              div.font-weight-bold.title.text-end(:class="getColor(item.amount)") {{ item.formattedAmount }}
                              v-icon.font-weight-bold.ml-1(:class="getColor(item.amount)" size="18") fas fa-euro-sign
                          v-col(cols="12" sm="12")
                            v-list-item-content
                              div.subtitle-1 {{item.description}}
            v-skeleton-loader(v-else type="paragraph@7 " width="100%")

</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter} from "vuex-class";
import {USER_LOGGED_IN} from '@/store/getter-types'
import {CurrentUser} from '@/model/CurrentUser'
import {FETCH_CREDIT_DETAILS, FETCH_DASHBOARD, USER_DAILY_MENU} from '@/store/action-types'
import {CreditDetails} from "@/model/CreditDetails";
import moment from "moment";
import {formatFloatPrice} from "@/services/formatter";

@Component({
  components: {

  }
})
export default class CreditPage extends Vue {

  private creditDetails: CreditDetails[] | null = null
  private fetchInProgress: boolean = false

  private snackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''

  @Getter(USER_LOGGED_IN) currentUser!: CurrentUser
  @Action(USER_DAILY_MENU) fetchDailyMenu!: ({ (payload: any): Promise<void> })
  @Action(FETCH_DASHBOARD) fetchDashboard!: ({ (): Promise<any> })
  @Action(FETCH_CREDIT_DETAILS) fetchCreditDetails!: ({ (): Promise<CreditDetails[]> })

  formatDate(date: string): string {
    return moment(date).format('DD.MM.YYYY')
  }

  getColor(value:number): string {
    if(value < 0){
      return 'red--text'
    }else if(value > 0){
      return 'green--text'
    }else{
      return ''
    }
  }

  async fetchData(): Promise<void> {
    this.fetchInProgress = true

    try {
      this.creditDetails = await this.fetchCreditDetails()
    } catch (e) {
      this.snackBar = true
      this.snackBarColor = 'alert'
      this.snackBarMessage = this.$t('errors.fetchDataError').toString()
    } finally {
      this.fetchInProgress = false
    }
  }

  mounted(): void {
    this.fetchData()
  }
}
</script>

<style lang="stylus" scoped>

</style>
